import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./RegistrationPage.css";

import bannerImage from "../../Assets/images/artwork.jpg";

const API_URL = process.env.REACT_APP_BACKEND_API_URL;

const RegistrationPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    organization: "",
    editionName: "",
    createdBy: "Website",
  });

  const [currentEdition, setCurrentEdition] = useState(null);
  const [loadingEdition, setLoadingEdition] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // ✅ SUCCESS STATE
  const [showSuccess, setShowSuccess] = useState(false);

  // ✅ NEW: CLOSED STATE (same idea as Cape Coast page)
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const fetchCurrentEdition = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/journeyman-editions/current`
        );

        if (response.data?.editionName) {
          setCurrentEdition(response.data);

          setFormData((prev) => ({
            ...prev,
            editionName: response.data.editionName,
          }));

          // ✅ If backend provides status, use it (preferred)
          setIsClosed(response.data.isClosed === true);
        } else {
          setCurrentEdition(null);
          setIsClosed(true);

          setFormData((prev) => ({
            ...prev,
            editionName: "No current Edition to Register",
          }));
        }
      } catch (error) {
        setCurrentEdition(null);
        setIsClosed(true);

        setFormData((prev) => ({
          ...prev,
          editionName: "No current Edition to Register",
        }));
      } finally {
        setLoadingEdition(false);
      }
    };

    fetchCurrentEdition();
  }, []);

  const handleChange = (e) => {
    if (!currentEdition || isClosed) return;

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ BLOCK SUBMISSION IF CLOSED
    if (isClosed || !currentEdition) return;

    if (!formData.fullName || !formData.organization) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      setSubmitting(true);

      await axios.post(`${API_URL}/journeyman-registrations`, formData);

      setShowSuccess(true);

      setFormData({
        fullName: "",
        phone: "",
        email: "",
        organization: "",
        editionName: currentEdition.editionName,
        createdBy: "Website",
      });

      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

    } catch (error) {
      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert("Error submitting registration");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleNavigate = () => {
    navigate("/ample-productions");
  };

  return (
    <section className="registration-page">
      <div className="registration-content">

        {/* LEFT */}
        <div className="registration-left">
          <div className="registration-header">
            <h1>RSVP</h1>

            <p className="welcome-text">
              We welcome you to the Journeyman Experience.
            </p>

            <p className="instruction-text">
              Please fill the form to confirm your attendance.
            </p>

            {/* fallback text */}
            {!loadingEdition && isClosed && (
              <p className="error-text">
                Registration is currently closed.
              </p>
            )}
          </div>

          <div className="registration-form-container">
            <form onSubmit={handleSubmit}>

              <div className="form-group">
                <label>Full Name <span className="required">*</span></label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  disabled={!currentEdition || isClosed}
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={!currentEdition || isClosed}
                />
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  disabled={!currentEdition || isClosed}
                />
              </div>

              <div className="form-group">
                <label>Organization <span className="required">*</span></label>
                <input
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  required
                  disabled={!currentEdition || isClosed}
                />
              </div>

              <button
                type="submit"
                className="btn-submit"
                disabled={submitting || !currentEdition || isClosed}
              >
                {isClosed
                  ? "Registration Closed"
                  : submitting
                  ? "Submitting..."
                  : "Register Now"}
              </button>

            </form>
          </div>
        </div>

        {/* RIGHT */}
        <div className="registration-banner-container">
          <img
            src={bannerImage}
            alt="Journeyman Banner"
            className="floating-banner clickable"
            onClick={handleNavigate}
          />

          <p className="banner-text" onClick={handleNavigate}>
            Coming Soon at the National Theatre of Ghana
          </p>

          <button className="banner-btn" onClick={handleNavigate}>
            Explore the Journeyman Experience
          </button>
        </div>

      </div>

      {/* ================= CLOSED / SUCCESS OVERLAY ================= */}
      {(showSuccess || isClosed) && (
        <div className="success-overlay">
          <div className="success-card">

            {showSuccess && (
              <>
                <div className="checkmark"></div>
                <h2>Registration Successful</h2>
                <p>You will receive an SMS shortly.</p>
              </>
            )}

            {isClosed && !showSuccess && (
              <>
                <h2>Registration Closed</h2>
                <p>Registration is closed for this year’s edition. Stay tuned for next year’s edition.</p>
              </>
            )}

            <button
              onClick={() => {
                setShowSuccess(false);
                setIsClosed(isClosed);
              }}
            >
              Close
            </button>

          </div>
        </div>
      )}

    </section>
  );
};

export default RegistrationPage;